// TYPES
export const INIT_APP_VIEW = 'INIT_APP_VIEW';
export const SAVE_APP_VIEW_STATE = 'SAVE_APP_VIEW_STATE';
export const SAVE_APP_VIEW_SEARCH_PARAMS = 'SAVE_APP_VIEW_SEARCH_PARAMS';

export const SEARCH_APP_VIEW_LIST = 'SEARCH_APP_VIEW_LIST';
export const INFINITE_SEARCH_APP_VIEW_LIST = 'INFINITE_SEARCH_APP_VIEW_LIST';

export const READ_EAPP_POLICY_PDF_URL = 'READ_EAPP_POLICY_PDF_URL';
export const READ_EAPP_COMPLETE = 'READ_EAPP_COMPLETE';

export const SAVE_RECEPT_PROCESSING_HISTORY = 'SAVE_RECEPT_PROCESSING_HISTORY';

// ACTIONS
export const initAppView = payload => {
  return { type: INIT_APP_VIEW, payload };
};
export const saveAppViewState = payload => {
  return { type: SAVE_APP_VIEW_STATE, payload };
};
export const saveAppViewSearchParams = payload => {
  return { type: SAVE_APP_VIEW_SEARCH_PARAMS, payload };
};

export const searchAppViewList = payload => {
  return { type: SEARCH_APP_VIEW_LIST, payload };
};
export const infiniteSearchAppViewList = payload => {
  return { type: INFINITE_SEARCH_APP_VIEW_LIST, payload };
};

export const readEappPolicyPdfUrl = payload => {
  return { type: READ_EAPP_POLICY_PDF_URL, payload };
};
export const readEappComplete = payload => {
  return { type: READ_EAPP_COMPLETE, payload };
};

export const saveReceptProcessingHistory = payload => {
  return { type: SAVE_RECEPT_PROCESSING_HISTORY, payload };
};
